import type { BackgroundTheme } from '@/types/color';
import { createContext, type FC, type ReactNode } from 'react';

export const BackgroundThemeContext = createContext<
  BackgroundTheme | undefined
>(undefined);

interface BackgroundThemeProviderProps {
  children: ReactNode;
  backgroundTheme: BackgroundTheme;
}

export const BackgroundThemeProvider: FC<BackgroundThemeProviderProps> = ({
  children,
  backgroundTheme,
}) => {
  return (
    <BackgroundThemeContext.Provider value={backgroundTheme}>
      {children}
    </BackgroundThemeContext.Provider>
  );
};
